export const HOMEPAGE = '/sii';

/**
 * Listado de páginas
 * @readonly
 * @enum {string}
 */
export const ROUTES = Object.freeze({
  HOME: '/',
  ACCESO_AUTORIZADO: '/acceso-autorizado',
  RECORDAR_CONTRASENA: '/recordar-contrasena',
  REESTABLECER_CONTRASENA: '/reestablecer-contrasena',
  FORMULAR_DENUNCIA: '/formular-denuncia',
  RECORDAR_NOTIFICACION: '/recordar-notificacion',
  CONSULTAR_DENUNCIA: '/detalle-denuncia',
  LISTADO_DENUNCIA: '/denuncias',
  BACK_OFFICE: '/backoffice',
  DOWNLOAD_COOKIES: '/download/cookies-policy',
});
